export const ALERT_MESSAGE_SEND = 'ALERT_MESSAGE_SEND';
